import React, { useState, useEffect } from 'react';
import { debounce } from '@mui/material';

import Search from 'src/components/search/Search';
import { useLeadMessagesPageContext } from 'src/pages/landlord/leads/messages/context/hooks';

const HELPER_TEXT = 'Search by snippet name or content';

export default function SnippetsSearch() {
    const [value, setValue] = useState('');
    const [isSearching, setSearching] = useState(false);

    const { search, setSearch } = useLeadMessagesPageContext();

    const setSearchQueryDebounced = debounce(setSearch, 300);

    useEffect(() => {
        setSearchQueryDebounced(value);
    }, [value, setSearchQueryDebounced]);

    useEffect(() => {
        if (value !== search) {
            setSearching(true);
        } else {
            setSearching(false);
        }
    }, [value, search]);

    return (
        <Search
            type="search"
            placeholder="Search snippets"
            value={value}
            onChange={setValue}
            size="small"
            fullWidth
            isLoading={isSearching}
            helperText={HELPER_TEXT}
            sx={{
                bgcolor: 'common.white',
                '@media (max-width: 1200px)': {
                    width: '100%',
                },
            }}
            data-testid="snippets-search-field"
        />
    );
}